const items = [
  { icon: "ri-shield-check-fill", label: "Licensed & Insured" },
  { icon: "ri-building-2-fill", label: "Residential & Commercial" },
  { icon: "ri-award-fill", label: "Premium Grade Materials" },
  { icon: "ri-map-pin-2-fill", label: "Proven Local Experience" },
];

export default function TrustBarSection() {
  return (
    <div className="bg-safety-500 py-0">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4">
          {items.map((item, i) => (
            <div
              key={item.label}
              className={`flex items-center justify-center gap-3 py-5 px-6 ${
                i < items.length - 1 ? "border-r border-safety-600" : ""
              }`}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${item.icon} text-asphalt-950 text-xl`} />
              </div>
              <span className="font-body text-asphalt-950 text-xs font-800 uppercase tracking-widest whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
